/**
 * Store admin — orders list (Commerce, M3).
 * @see prototype/store/admin/all.html#orders-list
 */
import { createFileRoute } from "@tanstack/react-router";
import { OrdersListPage } from "../../../../../features/store/orders/orders-list-page.tsx";

export const Route = createFileRoute("/(workspace)/store/admin/orders/")({
  component: OrdersListPage,
});
